import { useTheme } from 'styled-components';

import { FONT_BRIGHTNESS } from '@hivebrite/design-system/Theme';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

// Outboxed fonts are rendered directly on the BG of the network (not inside a Card or equivalent).
// They need to follow a special color to be visible on the BG (if BG is dark for ex., since fonts are dark by default)
const useOutboxedFontTheme = ({ network } = {}) => {
  const { currentNetwork } = useDefaultAppContexts();
  const theme = useTheme();

  const networkData = network || currentNetwork;

  if (theme?.themeName === 'bo') {
    return {
      fontBrightness: FONT_BRIGHTNESS.DARK,
      themeName: 'bo',
    };
  }

  return {
    fontBrightness: networkData?.theming?.fo?.fo_outboxed_font_brightness,
    themeName: 'fo',
  };
};

export default useOutboxedFontTheme;
